import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ShieldCheck, ShieldAlert, AlertTriangle, CheckCircle2 } from "lucide-react";

export const EthicsResultPanel = ({ ethics }) => {
  if (!ethics) return null;
  const approved = ethics.approved;
  return (
    <Card data-testid="ethical-screen-panel" className={`border-2 ${approved ? "border-[hsl(174,38%,70%)]" : "border-[hsl(6,62%,72%)]"}`}>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-base">
          {approved ? (
            <ShieldCheck className="h-5 w-5 text-[hsl(174,38%,34%)]" />
          ) : (
            <ShieldAlert className="h-5 w-5 text-destructive" />
          )}
          <span data-testid="ethical-screen-result">
            {approved ? "Ethical screening passed" : "Job rejected by ethical screening"}
          </span>
          <Badge variant="outline" className="ml-auto rounded-full text-[10px] uppercase tracking-wide">
            {ethics.risk_level} risk
          </Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3 text-sm">
        <p className="text-muted-foreground">{ethics.reasoning}</p>
        {ethics.violations?.length > 0 && (
          <div data-testid="ethical-screen-reasons" className="space-y-1.5">
            <p className="font-semibold text-destructive">Violations</p>
            {ethics.violations.map((v) => (
              <div key={v} className="flex items-start gap-2">
                <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-destructive" />
                <span>{v}</span>
              </div>
            ))}
          </div>
        )}
        {ethics.scope_warning && (
          <div data-testid="ethical-screen-scope-warning" className="flex items-start gap-2 rounded-xl border border-[hsl(43,74%,70%)] bg-[hsl(43,74%,94%)] p-3">
            <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[hsl(43,60%,30%)]" />
            <div>
              <p className="font-semibold text-[hsl(43,60%,22%)]">Media description needs more accuracy</p>
              <p className="text-[hsl(43,50%,25%)]">{ethics.scope_warning} Remember: your licence is limited to exactly the media you describe, and the fee is based on it.</p>
            </div>
          </div>
        )}
        {ethics.required_consents?.length > 0 && (
          <div className="space-y-1.5">
            <p className="font-semibold">Model consent required for</p>
            {ethics.required_consents.map((c) => (
              <div key={c} className="flex items-start gap-2">
                <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[hsl(174,38%,34%)]" />
                <span>{c}</span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
